import { Module } from 'vuex'
import { CartEntry } from './cart'

export interface OrderDetails {
  ref: string
  name: string
  phone: string
  address: string
  deliveryTime: string
  paymentMethod: string
  items: CartEntry[]
  total: number
  placedAt: string
}

export interface OrderState {
  current: OrderDetails | null
}

const order: Module<OrderState, unknown> = {
  namespaced: true,
  state: () => ({ current: null }),
  getters: {
    current: (s) => s.current
  },
  mutations: {
    SET (state, details: OrderDetails) {
      state.current = details
    },
    CLEAR (state) {
      state.current = null
    }
  },
  actions: {
    place ({ commit }, details: OrderDetails) {
      commit('SET', details)
    },
    clear ({ commit }) {
      commit('CLEAR')
    }
  }
}

export default order
